<template>
  <v-app
    id="webwalker"
    :class="{ 'is-auth': isAuthView }"
  >
    <main-nav
      v-if="!isAuthView"
      @logout="logout()"
    ></main-nav>

    <v-main
      :class="isAuthView ? 'auth-main bg-blue-darken-3' : 'background'"
    >
      <router-view v-slot="{ Component, route }">
        <transition-container>
          <component
            :is="Component"
            :key="route.path"
          />
        </transition-container>
      </router-view>
    </v-main>
  </v-app>
</template>

<script>
import AuthApi from '@/api/AuthApi';
import MainNav from '@/components/layout/MainNav.vue';
import TransitionContainer from '@/components/layout/TransitionContainer.vue';
import { setDarkMode } from '@/helpers/vuetifyTheme';

export default {
  name: 'WebwalkerBilling',

  components: {
    MainNav,
    TransitionContainer,
  },

  data: () => ({
    interval: null,
    refreshInterval: 60,
  }),

  computed: {
    isDarkMode() {
      return this.$store.state.isDarkMode;
    },

    isAuthView() {
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
  },

  watch: {
    isDarkMode(val) {
      setDarkMode(val);
      this.rootScrollColor();
    },

    $route() {
      this.$store.dispatch('clearErrors');
    },
  },

  mounted() {
    this.loadData();
    this.interval = setInterval(() => {
      this.loadData();
    }, this.refreshInterval * 1000);
    this.rootScrollColor();
  },

  beforeUnmount() {
    if (this.interval) clearInterval(this.interval);
  },

  methods: {
    loadData() {
      this.$store.dispatch('loadAdmin');
      setDarkMode(this.$store.state.isDarkMode);
    },

    logout() {
      AuthApi.logout()
        .then(() => {
          localStorage.clear();
          window.location.reload();
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('pushErrors', error.response.data.errors);
          }
          localStorage.clear();
        });
    },

    rootScrollColor() {
      const root = document.querySelector(':root');
      if (this.isDarkMode) {
        root.classList.add('scroll-dark');
      } else {
        root.classList.remove('scroll-dark');
      }
    },
  },
};
</script>
